import { Module } from "vuex";
import { RootState } from "..";
import { initRudderStack, rsPage, rsTrack, rsIdentify } from "@/analytics/rudderstack";

export default <Module<RootState, RootState>>{
    namespaced: false,

    mutations: {
        INIT_RUDDERSTACK() {
            initRudderStack();
        },

        LOG_RS_SCREEN(state, screenName: string) {
            rsPage(screenName);
        },

        LOG_RS_EVENT(state, payload: { event: string; params?: Record<string, any> }) {
            rsTrack(payload.event, payload.params);
        },

        LOG_RS_IDENTIFY(state, payload: { userId: string; traits?: Record<string, any> }) {
            rsIdentify(payload.userId, payload.traits);
        },
    },
};
